import { useEffect, useState } from 'react';
import Transform from '../../components/TransForm/Transform';
import StyledTable from '../../components/table-component/StyledTable';
import { useDispatch, useSelector } from 'react-redux';
import BaseParameter from '../../data/schemas/baseParameter';
import { createProgram, deleteProgram, fetchProgrammes, updateProgram } from '../../data/slices/programmeSlice';
import { notify } from '../../settings/toastSetting';
import { Dialog, Box, Paper, Typography } from '@mui/material';
import { Add, Assignment } from '@mui/icons-material';
import { output, sortByProp, COLORS } from '../../settings/themeSettings';
import PageHeader from '../../components/layout/PageHeader';

const ProgrammePage = (props) => {
    const { programmes } = useSelector((state) => state.programmes);
    const dispatch = useDispatch();

    const [program, setProgram] = useState(null);
    const [open, setOpen] = useState(false);

    const handleClose = () => {
        setOpen(false);
        setProgram(null);
    }

    const addProgramme = (data, cb) => {
        handleClose();
        if (data.id) {
            updateProgram(data, (err) => output(err), (resp) => {
                cb();
                notify("Le programme a été enregistré avec succès !");
                dispatch(fetchProgrammes());
            });
            return;
        }

        createProgram(data, (err) => output(err), (resp) => {
            cb();
            notify("Le programme a été ajouté avec succès !");
            dispatch(fetchProgrammes());
        });
    }

    const onProgramSelected = (id) => {
        setProgram(programmes.find((p) => p.id === id));
        setOpen(true);
    }   

    const onDelete = (id) => {
        handleClose();
        deleteProgram(id, (err) => output(err), (resp) => {
            setProgram(null);
            notify("Le programme a bien été supprimé !");
            dispatch(fetchProgrammes());
        });
    }

    useEffect(() => {
        dispatch(fetchProgrammes());
    }, [dispatch]);

    return (
        <Box sx={{ p: { xs: 2, md: 4 }, bgcolor: '#f8fafc', minHeight: '100vh' }}>
            <PageHeader 
                title="Gestion des Programmes"
                subtitle="Configurez les différents types de programmes pour vos dossiers"
                icon={Assignment}
                breadcrumbs={[
                    { label: 'Paramètres', path: '/parametres' },
                    { label: 'Programmes', path: '/parametres/programmes' }
                ]}
                actions={[
                    { 
                        label: 'Ajouter un programme', 
                        icon: <Add />, 
                        onClick: () => { setProgram(null); setOpen(true); },
                        color: 'primary'
                    }
                ]}
            />

            <Paper elevation={0} sx={{ 
                borderRadius: '16px', 
                overflow: 'hidden', 
                border: '1px solid',
                borderColor: COLORS.gray[200],
                bgcolor: 'white'
            }}>
                <Box sx={{ p: 2, borderBottom: '1px solid', borderColor: COLORS.gray[100], bgcolor: COLORS.gray[50] }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 700, color: COLORS.secondary, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                        Liste des programmes ({programmes.length})
                    </Typography>
                </Box>
                
                <StyledTable
                    rows={[...programmes].sort((a,b) => sortByProp(a, b, 'libelle'))}
                    head={Object.keys(new BaseParameter())}
                    onOptionClicked={onProgramSelected}
                />
            </Paper>

            <Dialog 
                open={open} 
                onClose={handleClose}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: { borderRadius: '20px', p: 1 }
                }}
            >
                <Transform
                    onSubmit={addProgramme}
                    mandatories={["libelle"]}
                    entity={new BaseParameter()}
                    toUpdate={program}
                    onDelete={onDelete}
                    onCancel={handleClose}
                />
            </Dialog>
        </Box>
    );
}

export default ProgrammePage;
